import { forwardRef, useState } from 'react'
import { Button, Dialog, DialogContent, Typography, DialogTitle, Slide } from '@mui/material'

import UpdatingPage from './UpdatingPage'
import { useServiceWorker } from '../contexts/ServiceWorkerContext'

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const FrontUpdateAvailable = () => {
  const { isUpdateAvailable, updateAssets } = useServiceWorker()
  const [isUpdating, setIsUpdating] = useState(false)

  const handleReload = () => {
    if (!isUpdateAvailable) return

    setIsUpdating(true)
    updateAssets()
  }

  return (
    <>
      <Dialog
        open={isUpdateAvailable}
        slots={{ transition: Transition }}
        keepMounted
        disableEscapeKeyDown  // Prevent closing
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {  // Only allow button click
            handleReload()
          }
        }}
      >
        <DialogTitle>✨ Nouvelle mise à jour</DialogTitle>
        
        <DialogContent>
          <Typography variant="body1" mt={2} gutterBottom>
            Cliquez sur continuer et patientez un instant.
          </Typography>
        </DialogContent>

        <Button 
          color="primary" 
          variant="contained" 
          onClick={handleReload} 
          sx={{ maxWidth: '200px', margin: '20px auto' }}
        >
          Continuer
        </Button>
      </Dialog>
    
      {isUpdating && <UpdatingPage />} {/* Only show when updating */}
    </>
  )
}

export default FrontUpdateAvailable